import React, { useState } from "react";

const linkCopyResetTime = 2000; // (ms)

const CopyButton = ({ textToCopy }) => {
  const [copied, setCopied] = useState(false);

  if (!copied) {
    return (
      <button
        onClick={() => {
          const el = document.createElement("textarea");
          el.value = textToCopy;
          el.setAttribute("readonly", "");
          el.style.position = "absolute";
          el.style.left = "-9999px";
          document.body.appendChild(el);
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
          setCopied(true);
          setTimeout(() => {
            setCopied(false);
          }, linkCopyResetTime);
        }}
        className="confirm-button growth-button edit-root-small-copy"
      >
        COPY
      </button>
    );
  } else {
    return (
      <div className="edit-root-small-copy growth-color w-100">
        Link Copied!
      </div>
    );
  }
};

export default CopyButton;
